import extend from 'extend';
import Q from 'q';
import _ from 'underscore';
import BaseEntitySelector from '../../../yinzhilv/base-entity-selector-0000/1.0.1/index.vue';
import consumer_web_bank_getBankList from '../../../../lib/common-service/haolv/consumer_web_bank_getBankList';

export default {
    components: {
        BaseEntitySelector,
    },
    props: {
        value: {
            // type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            value_for_v_model: null,
        };
    },
    watch: {
        value(pNewValue, pOldValue) {
            const __this = this;
            __this.value_for_v_model = pNewValue;
        },
        value_for_v_model(pNewValue, pOldValue) {
            const __this = this;
            __this.$emit('input', pNewValue);
        },
    },
    methods: {},
    created() {
    },
    mounted() {
        const __this = this;
        __this.$refs.aBaseEntitySelector.init({
            entity_define: {
                property_name_for_code: `id`,
                property_name_for_name: `bankName`,
                property_name_for_pin_yin: `id`,
                property_name_for_jian_pin: `id`,
                property_name_for_first_letter: `id`,
            },
            get_data_source() {
                return Q.when()
                    .then(function () {
                        return consumer_web_bank_getBankList();
                    })
                    .then(function (data) {
                        const all_entity_list = data.datas;

                        const o = {};
                        o.all_entity_list = all_entity_list;
                        return o;
                    })
                    ;
            },
            panel_select_entity: {
                get_tab_list(pParameter) {
                    const o = {};
                    o.tab_list = [];
                    return Q.resolve(o);
                },
            },
            panel_filter_entity: {
                title: `名称`,
                is_show_code: false,
            },
            panel_use_situation: `100`,
        });
    },
}
